import { getPanelName } from 'helpers/helper'
import { useEffect, useState } from 'react'

const CloudHosting = ({ currentProduct, hostingProduct, setHostingProduct }) => {
	const { name } = currentProduct.current
	const [selectedPanel, setSelectedPanel] = useState({
		name: null,
		panel: null,
		backup: "netral",
	})
	const [valueBackup, setValueBackup] = useState("")
	const [additionalCost, setAdditionalCost] = useState("")

	const extractProductName = (productName) => {
		const match = productName.match(/^Cloud Hosting\s+(.+?)(?:\s+\(.+?\))?(?:\s+\+.*)?$/i);
		return match ? match[1].trim() : productName;
	};

	useEffect(() => {
		const baseName = extractProductName(name);
		const hasBackup = name.includes("+ Backup Harian");
		
		setSelectedPanel({
			name: baseName,
			panel: getPanelName(name),
			backup: hasBackup ? "backup" : "netral"
		})

		setValueBackup(hasBackup ? " + Backup Harian" : "Mingguan");
	}, [name])

	// Calculate additional cost based on PID
	useEffect(() => {
		const additionalCostPidList1 = [
			529, 527, 533, 531, 1020, 1021, 1025, 1028, 1039, 1042, 1053, 1056, 1067, 1070, 1024, 1038, 1052, 1066,
		];
		const additionalCostPidList2 = [
			537, 535, 541, 539, 1022, 1026, 1040, 1029, 1043, 1057, 1071, 1054, 1068,
		];
		const additionalCostPidList3 = [
			1023, 1027, 1041, 1055, 1069, 1044, 1030, 1058, 1072,
		];
		const additionalCostPidList4 = [1088, 1090, 1092, 1094];

		const pid = hostingProduct.productDetails?.pid;

		if (additionalCostPidList1.includes(pid)) {
			setAdditionalCost("+ Rp15.000/bulan");
		} else if (additionalCostPidList2.includes(pid)) {
			setAdditionalCost("+ Rp20.000/bulan");
		} else if (additionalCostPidList3.includes(pid)) {
			setAdditionalCost("+ Rp40.000/bulan");
		} else if (additionalCostPidList4.includes(pid)) {
			setAdditionalCost("+ Rp80.000/bulan");
		} else {
			setAdditionalCost("");
		}
	}, [hostingProduct.productDetails]);

	const addBackupHandler = (e) => {
		const newBackupValue = e.target.value;
		setValueBackup(newBackupValue);
		
		const baseName = extractProductName(name);
		const isBackup = newBackupValue === " + Backup Harian";
		
		setSelectedPanel(prev => ({
			...prev,
			name: baseName,
			backup: isBackup ? "backup" : "no-backup"
		}));
	}

	useEffect(() => {
		if (selectedPanel.panel && hostingProduct.productPanel) {
			const directAdminArr = hostingProduct.productPanel[0].directAdmin;
			
			const directAdminFiltered = directAdminArr.find((item) => {
				const itemBaseName = extractProductName(item.name);
				const currentBaseName = selectedPanel.name;
				
				if (selectedPanel.backup === "backup") {
					return itemBaseName === currentBaseName && item.name.includes("+ Backup Harian");
				} else if (selectedPanel.backup === "no-backup") {
					return itemBaseName === currentBaseName && !item.name.includes("+ Backup Harian");
				}
				return false;
			});

			if (directAdminFiltered && directAdminFiltered.pid !== hostingProduct.pid) {
				setHostingProduct({
					type: 'SET_CURRENT_PID',
					payload: directAdminFiltered.pid,
				});
			}
		}
	}, [hostingProduct.productPanel, selectedPanel, setHostingProduct, hostingProduct.pid]);

	return (
		<>
			<div className="row align-items-end mb-3">
				<div className="col-lg-12 col-12">
					<div className="row mb-2">
						<div className="col-6">
							<label className="fw-bold">Opsi Backup:</label>
						</div>
						{additionalCost && (
							<div className="col-6 text-end">
								<span
									className="text-black fw-bold"
									style={{ fontSize: "14px" }}
								>
									{additionalCost}
								</span>
							</div>
						)}
					</div>
					<div className="col-12"> 
						<select
							className="form-select"
							aria-label="Default select example"
							name="backup"
							id="backup"
							onChange={addBackupHandler}
							value={valueBackup}
						>
							<option value="Mingguan">Mingguan</option>
							<option value=" + Backup Harian">Harian</option>
						</select>
					</div>
				</div>
			</div>
		</>
	)
}

export default CloudHosting
